// Custom error classes for better error handling
export class ApiConfigurationError extends Error {
  constructor(message = 'API configuration error') {
    super(message);
    this.name = 'ApiConfigurationError';
    this.code = 'API_CONFIG_ERROR';
  }
}

export class ApiRequestError extends Error {
  constructor(message = 'API request failed', status = null) {
    super(message);
    this.name = 'ApiRequestError';
    this.code = 'API_REQUEST_ERROR';
    this.status = status;
  }
}

// Helper function to get API URL with proper URL construction
export const getApiUrl = (endpoint) => {
  const baseUrl = import.meta.env.VITE_API_URL;
  
  if (!baseUrl) {
    console.error('VITE_API_URL environment variable is not set');
    throw new ApiConfigurationError('VITE_API_URL is not defined');
  }
  
  try {
    // Use URL constructor to handle slashes properly
    return new URL(endpoint, baseUrl).toString();
  } catch (error) {
    console.error('Invalid API URL configuration:', error);
    throw new ApiConfigurationError('Invalid API URL configuration');
  }
};

// Helper function to get reCAPTCHA site key
export const getRecaptchaSiteKey = () => {
  const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
  
  if (!siteKey) {
    console.warn('VITE_RECAPTCHA_SITE_KEY environment variable is not set');
    return null;
  }
  
  return siteKey;
};
